var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInspection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.3444,
    cy: 36.3913,
    r: 36.3913,
    fill: "#4C97E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5292 14.8027H39.1931C39.1931 16.1597 38.0829 17.2699 36.7259 17.2699C35.369 17.2699 34.2587 16.1597 34.2587 14.8027H21.9227C19.2088 14.8027 16.9883 17.0232 16.9883 19.7371V59.2125C16.9883 61.9264 19.2088 64.1469 21.9227 64.1469H51.5292C54.2431 64.1469 56.4636 61.9264 56.4636 59.2125V19.7371C56.4636 17.0232 54.2431 14.8027 51.5292 14.8027Z",
    fill: "#455A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5276 60.4474H21.9211C21.1809 60.4474 20.6875 59.954 20.6875 59.2138V19.7385C20.6875 18.9983 21.1809 18.5049 21.9211 18.5049H51.5276C52.2678 18.5049 52.7612 18.9983 52.7612 19.7385V59.2138C52.7612 59.954 52.2678 60.4474 51.5276 60.4474Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1946 14.8018C39.1946 16.1587 38.0844 17.269 36.7274 17.269C35.3705 17.269 34.2602 16.1587 34.2602 14.8018H25.625V19.7362C25.625 21.0931 26.7352 22.2034 28.0922 22.2034H45.3627C46.7196 22.2034 47.8299 21.0931 47.8299 19.7362V14.8018H39.1946Z",
    fill: "#90A4AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7274 9.86816C34.0135 9.86816 31.793 12.0887 31.793 14.8026C31.793 17.5165 34.0135 19.737 36.7274 19.737C39.4413 19.737 41.6618 17.5165 41.6618 14.8026C41.6618 12.0887 39.4413 9.86816 36.7274 9.86816ZM36.7274 17.2698C35.3704 17.2698 34.2602 16.1595 34.2602 14.8026C34.2602 13.4456 35.3704 12.3354 36.7274 12.3354C38.0843 12.3354 39.1946 13.4456 39.1946 14.8026C39.1946 16.1595 38.0843 17.2698 36.7274 17.2698Z",
    fill: "#90A4AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8676 32.8135L33.7651 43.9159L28.584 38.6114L25.5 41.6954L33.8885 49.9606L47.9516 35.8975L44.8676 32.8135Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection);
export default __webpack_public_path__ + "static/media/inspection.b4765d0a9b233cd92cc6c0eda3233e21.svg";
export { ForwardRef as ReactComponent };